module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('masthead'), _vm._v(" "), _c('div', {
    staticClass: "bg_image"
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d91227f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 862
// module chunks = 2